import { HttpClient } from '@angular/common/http';
import { Client } from './client';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@morningstar/shared/environment';
import { catchError } from 'rxjs/operators';
import { GenericErrorHandler } from '@morningstar/shared/base/error-handler';

@Injectable()
export class ClientService {

  constructor(private httpClient: HttpClient) { }

  getClientsByLocation(location: string,
                       ignoreStatus: boolean = false,
                       includeFutureClients: boolean = false,
                       includeMasters: boolean = true,
                       includeParticipants: boolean = true): Observable<Client[]> {
    let endpoint = `${environment.spaceGeekUrl}${environment.api.clients}`
                      .replace('{location}', location)
                      .replace('{ignoreStatus}', ignoreStatus.toString());

    if (includeFutureClients) {
      endpoint += '&includeFutureClients=true';
    }

    endpoint += `&includeMasters=${includeMasters}`;
    endpoint += `&includeParticipants=${includeParticipants}`;

    return this.httpClient.get<Client[]>(endpoint).pipe(
      catchError(GenericErrorHandler.handleError<Client[]>('getClients'))
    );
  }
}
